<template>
  <div
    v-if="
      $store.state.page >= showFromPage && !$store.state.customer_link_reloaded
    "
    class="ms-auto w-md-auto mt-2"
  >
    <div class="container">
      <div
        class="mb-3 ms-md-auto flex-grow-1 w-100 w-md-auto flex-md-grow-0 connection"
      >
        <button
          v-if="showGenerateButton"
          :disabled="linkButtonValid"
          class="btn btn-red claim-identifier ms-auto w-md-auto mt-2"
          @click="showModal"
        >
          {{ linkButtonName }}
        </button>
      </div>
      <div class="row justify-content-end">
        <div class="col-12 d-flex justify-content-end">
          <div
            v-if="showGenerateButton && $store.state.merchant_id !== 'colo213'"
            class="right-half text-end"
          >
            <button
              :disabled="linkButtonValid"
              class="btn btn-red claim-identifier mt-2"
              @click="showModalCustomer"
            >
              {{ linkButtonNameCustomer }}
            </button>

            <div class="text-danger mt-2 text-wrap text-break">
              Felhívjuk figyelmét, hogy amennyiben az ügyfélnek elküldi a linket
              megkötésre, és az ügyfél megköti a biztosítást, akkor Ön ezt a
              díjszámítást ne véglegesítése, mert abban az esetben az ügyfélnek
              két érvényes, élő biztosítása lesz!
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Swal from "sweetalert2";
export default {
  props: ["showFromPage"],
  data() {
    return {
      show: false,
      message: "asdaasdasd",
      linkButtonName: "Link Generálása",
      linkButtonNameCustomer:
        "Link generálása és küldése az ügyfél email címére",
    };
  },
  methods: {
    generateLink() {
      this.$store.commit("setGenerateLink", 1);
      // console.log(this.$store.state.save_request_uid);
      this.$store.dispatch(
        "getSavedDataByUid",
        this.$store.state.save_request_uid
      );
    },
    showModal() {
      this.$gtm.trackEvent({
        event: "generatelink", // Event type [default = 'interaction'] (Optional)
        label: "generatelink",
        category: "Calculator",
        action: "click",
        page: this.$store.state.page,
        noninteraction: false, // Optional
        transaction_id: this.$store.state.product_code,
      });
      //this.$store.commit('setSaveURL', '');
      this.$store.commit("setGenerateLink", 1);
      this.linkButtonName = "Kérem várjon";
      this.$store.commit("setClaimIdentifier", "generatelink");
      // console.log("link generation!!")
      this.$store.dispatch("verifyPage");
    },
    showModalCustomer() {
      // this.$gtm.trackEvent({
      //   event: 'generatelink', // Event type [default = 'interaction'] (Optional)
      //   label: 'generatelink',
      //   category: 'Calculator',
      //   action: 'click',
      //   page: this.$store.state.page,
      //   noninteraction: false, // Optional
      //   transaction_id: this.$store.state.product_code,
      // });
      // this.$store.commit('setClaimIdentifier', 'generatelink');
      // console.log("link generation!!")
      this.$store.dispatch("generateClientLink");
    },
  },
  computed: {
    linkButtonValid() {
      if (this.linkButtonName === "Kérem várjon") return true;
      return !this.$store.state.canProceedToNextPage;
    },
    fetchURL() {
      return this.$store.state.fetch_url;
    },
    customerFetchURL() {
      return this.$store.state.customer_fetch_url;
    },
    showGenerateButton() {
      let page = this.$store.state.page;
      let isDM = this.$store.state.dm;
      return page >= 1;
    },
  },
  watch: {
    fetchURL() {
      if (this.$store.state.fetch_url != null) {
        Swal.fire({
          input: "text",
          inputValue: this.fetchURL,
          inputAttributes: {
            disabled: false,
          },
          text: "Az alábbi linken keresztül érheti el a jelenlegi ",
          confirmButtonText: "Másolás Vágólapra",
          confirmButtonColor: "#E4002C",
        }).then(() => {
          navigator.clipboard.writeText(this.fetchURL);
          Swal.fire("Link másolva a vágólapra");
        });
      }
      this.linkButtonName = "Link Generálása";
    },
    customerFetchURL(newVal) {
      if (newVal) {
        Swal.fire({
          html: `
        <p>Link küldése emailben az ügyfélnek</p>
        <p style="color:#dc3545; margin-top:8px;">
          <strong>Felhívjuk figyelmét</strong>, hogy amennyiben az ügyfélnek elküldi a linket megkötésre, és az ügyfél megköti a biztosítást, akkor Ön ezt a díjszámítást ne véglegesítse, mert abban az esetben az ügyfélnek két érvényes, élő biztosítása lesz!
        </p>
      `,
          confirmButtonText: "Email elküldése",
          confirmButtonColor: "#E4002C",
          showCancelButton: true,
          cancelButtonText: "Mégse",
          reverseButtons: true,
          showLoaderOnConfirm: true,
          allowOutsideClick: () => !Swal.isLoading(),
          preConfirm: () => {
            return this.$store.dispatch("sendEmailToCustomer").catch((err) => {
              Swal.showValidationMessage(`Hiba: ${err?.message || err}`);
              throw err;
            });
          },
        }).then((result) => {
          if (result.isConfirmed) {
            Swal.fire("Email elküldve");
          }
        });
      }
      this.linkButtonNameCustomer =
        "Link generálása és küldése az ügyfél email címére";
    },
  },
};
</script>
<style>
.right-half {
  max-width: 100%;
}
@media (min-width: 992px) {
  .right-half {
    max-width: 50%;
  }
}
</style>
